export default "__VITE_ASSET__BFqxixCL__"